import { render } from "./Financeiro.vue?vue&type=template&id=2595f8dd&scoped=true"
import script from "./Financeiro.vue?vue&type=script&lang=js"
export * from "./Financeiro.vue?vue&type=script&lang=js"

import "./Financeiro.vue?vue&type=style&index=0&id=2595f8dd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2595f8dd"]])

export default __exports__